import ArrowRight from "@mui/icons-material/ArrowRightAlt";
import Box from "@mui/material/Box";
import dayjs from "dayjs";
import BaseTag from "./BaseTag";

const formatToFullDate = (date) => date.format("DD-MMM-YYYY");

const RangeDate = (props) => (
  <Box display="flex">
    <Box>{props.startDate}</Box>
    <Box>
      <ArrowRight />
    </Box>
    <Box className="Label">{props.endDate}</Box>
  </Box>
);

const Label = (props) => {
  const { start, end } = props.value;
  const startDate = dayjs(start);
  const s = formatToFullDate(startDate);
  if (start === end) {
    return s;
  }
  const endDate = dayjs(end);
  const e = formatToFullDate(endDate);
  if (startDate.year() === endDate.year()) {
    if (startDate.month() === endDate.month()) {
      const s = startDate.date();
      if (s === 1 && startDate.endOf("month").date() === endDate.date()) {
        return startDate.format("MMM-YYYY");
      }
      return <RangeDate startDate={s} endDate={e} />;
    }
    const s = startDate.format("DD-MMM");
    return <RangeDate startDate={s} endDate={e} />;
  }
  return <RangeDate startDate={s} endDate={e} />;
};

const DateTag = (props) => (
  <BaseTag icon={props.icon} label={<Label value={props.value} />} />
);

export default DateTag;
